export { login } from 'next-flight-server-reference-proxy-loader?id=7f188af9fa0001f788a2b3be75fb77d7075266995f&name=login!'